<template>
  <v-data-table
    hide-default-footer
    disable-pagination
    :headers="isMei ? headersMei : headers"
    :items="resposta.produtos"
    item-key="id"
    class="elevation-0"
  >
  <template v-slot:item.cotacaoProduto.produto.descricao="{ item }">
    <px-produto-descricao
      :especificacao="item.cotacaoProduto.especificacaoProduto"
      :produto="item.cotacaoProduto.produto"/>
    </template>
    <template v-slot:item.quantidade="{ item }">
          <span>
            {{ item.cotacaoProduto.quantidade
            | number(getCurrencyFormat(item.cotacaoProduto.produto.casasDecimais)) }}&nbsp;
            {{ item.cotacaoProduto.unidadeMedida.descricao }}
          </span>
    </template>
    <template v-slot:item.precoUnitario="{ item }">
      <span v-if="isRespondida(item)">
        {{ item.precoUnitario | currency(simboloMoeda,
        item.cotacaoProduto.produto.casasDecimais,
        configuracaoFormatacaoMoeda) }}
      </span>
    </template>
    <template v-slot:item.icms="{ item }" v-if="!isMei">
      <px-imposto v-if="isRespondida(item)"
      :imposto="item.impostos"
      :simbolo-moeda="simboloMoeda"
      :configuracao-moeda="configuracaoFormatacaoMoeda"
      tipo="ICMS"
      :scale="item.cotacaoProduto.produto.casasDecimais"/>
    </template>
    <template v-slot:item.ipi="{ item }" v-if="!isMei">
      <px-imposto v-if="isRespondida(item)"
      :imposto="item.impostos"
      :simbolo-moeda="simboloMoeda"
      :configuracao-moeda="configuracaoFormatacaoMoeda"
      tipo="IPI"
      :scale="item.cotacaoProduto.produto.casasDecimais"/>
    </template>
    <template v-slot:item.total="{ item }">
      <span v-if="isRespondida(item)">
        {{ item.total | currency(simboloMoeda,
        item.cotacaoProduto.produto.casasDecimais,
        configuracaoFormatacaoMoeda) }}
      </span>
      <px-situacao-cotacao-produto :situacao="item.situacao"/>
    </template>
    <template v-slot:footer>
      <v-row dense class="text-right text--primary">
        <v-col cols="12" sm="6" class="body-1">
          <span class="font-weight-bold">
            FRETE: {{ resposta.frete.totalTransporte | currency(simboloMoeda,
            2,
            configuracaoFormatacaoMoeda) }}
          </span>
        </v-col>
        <v-col cols="12" sm="6" class="body-1">
          <span class="orange--text text--darken-4 font-weight-bold">
            TOTAL: {{ total | currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda) }}
          </span>
        </v-col>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import currency from 'currency.js';
import {
  SituacaoRespostaCotacaoProduto,
  AplicacaoImposto,
  FinalidadeCompra,
} from 'px-business-components';
import { CasaDecimalUtils } from 'px-components';
import moedaMixin from '@/mixins/moeda-mixin';
import { DEFAULT_PRECISION } from './resposta-utils';

export default {
  mixins: [moedaMixin],
  props: {
    resposta: Object,
    moeda: {
      type: String,
    },
  },
  data() {
    return {
      casaDecimal: null,
      headers: [
        {
          text: 'Produto',
          sortable: false,
          value: 'cotacaoProduto.produto.descricao',
        },
        {
          text: 'Quantidade',
          value: 'quantidade',
          sortable: false,
        },
        {
          text: 'Preço unitário',
          value: 'precoUnitario',
        },
        {
          text: 'ICMS',
          value: 'icms',
          sortable: false,
        },
        {
          text: 'IPI',
          value: 'ipi',
          sortable: false,
        },
        {
          text: 'Total',
          value: 'total',
        },
      ],
      headersMei: [
        {
          text: 'Produto',
          sortable: false,
          value: 'cotacaoProduto.produto.descricao',
        },
        {
          text: 'Quantidade',
          value: 'quantidade',
          sortable: false,
        },
        {
          text: 'Preço unitário',
          value: 'precoUnitario',
        },
        {
          text: 'Total',
          value: 'total',
        },
      ],
    };
  },
  computed: {
    isRespondida() {
      return item => item.situacao === SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
    isIsento() {
      return tipoAplicacao => tipoAplicacao
        === AplicacaoImposto.keys.ISENTO.key;
    },
    isIncluso() {
      return tipoAplicacao => tipoAplicacao
        === AplicacaoImposto.keys.INCLUSO.key;
    },
    isMei() {
      return !!this.resposta.fornecedor?.mei;
    },
    total() {
      const produtos = this.resposta.produtos
        .filter(produto => this.isRespondida(produto))
        .map(produto => produto.total)
        .reduce((a, b) => a + b);
      return currency(produtos, { precision: DEFAULT_PRECISION })
        .add(currency(this.resposta.frete.totalTransporte))
        .value;
    },
    totalProdutos() {
      return this.resposta.produtos
        .filter(produto => this.isRespondida(produto))
        .map(a => a.totalProdutos)
        .reduce((a, b) => a + b);
    },
    checkCodigo() {
      return item => item.codigo;
    },
    labelCodigo() {
      return item => `${item.codigo} -`;
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
  },
  methods: {
    calculateTotalProduto(produto) {
      return currency(produto.cotacaoProduto.quantidade, { precision: DEFAULT_PRECISION })
        .multiply(currency(produto.precoUnitario, { precision: DEFAULT_PRECISION })).value;
    },
    isContribuinte() {
      return this.resposta.cotacao?.comprador?.pessoa?.ies
        && Array.isArray(this.resposta.cotacao.comprador.pessoa.ies)
        && this.resposta.cotacao.comprador.pessoa.ies.length > 0;
    },
    isIpiCompoeBaseCalculoIcms(produto) {
      return !this.isContribuinte()
      || !(produto.finalidadeCompra === FinalidadeCompra.keys.INDUSTRIALIZACAO.key
            || produto.finalidadeCompra === FinalidadeCompra.keys.REVENDA.key);
    },
    calculateIcms(produto) {
      if (!produto?.impostos?.icms) {
        return 0;
      }

      let totalProdutos = currency(produto.totalProdutos, { precision: DEFAULT_PRECISION })
        .add(currency(produto?.frete || 0, { precision: DEFAULT_PRECISION }));

      if (this.isIpiCompoeBaseCalculoIcms(produto.cotacaoProduto)) {
        totalProdutos = totalProdutos.add(produto.impostos?.valorIpi || 0);
      }

      return totalProdutos.multiply(produto.impostos.icms).value;
    },
    calculateIpi(produto) {
      if (!produto?.impostos?.ipi) {
        return 0;
      }

      const totalProdutos = currency(produto.totalProdutos, { precision: DEFAULT_PRECISION })
        .add(currency(produto?.frete || 0, { precision: DEFAULT_PRECISION }));

      return totalProdutos.multiply(produto.impostos.ipi).value;
    },
    calculateTotal(produto) {
      return currency(produto.totalProdutos, { precision: DEFAULT_PRECISION })
        .add(currency(produto.impostos?.valorIpi || 0, { precision: DEFAULT_PRECISION }))
        .value;
    },
    calculatePercentualRateio(produto) {
      if (this.resposta.frete.totalTransporte === 0) {
        return 0;
      }
      return currency(produto.totalProdutos, { precision: DEFAULT_PRECISION })
        .multiply(100)
        .divide(currency(this.totalProdutos, { precision: DEFAULT_PRECISION }))
        .value;
    },
    calculateFreteItem(produto) {
      if (this.resposta.frete.totalTransporte === 0) {
        return 0;
      }
      return currency(produto.percentualRateio, { precision: DEFAULT_PRECISION })
        .multiply(this.resposta.frete.totalTransporte)
        .divide(100)
        .value;
    },
    calculateTotalProdutos() {
      this.resposta.produtos.forEach((produto) => { /* eslint-disable no-param-reassign */
        if (!this.isRespondida(produto)) {
          return;
        }
        produto.totalProdutos = this.calculateTotalProduto(produto);
      });
    },
    calculateProdutos() {
      this.resposta.produtos.forEach((produto) => { /* eslint-disable no-param-reassign */
        if (!this.isRespondida(produto)) {
          return;
        }
        produto.percentualRateio = this.calculatePercentualRateio(produto);
        produto.frete = this.calculateFreteItem(produto);
        produto.impostos.valorIpi = this.calculateIpi(produto);
        produto.impostos.valorIcms = this.calculateIcms(produto);
        produto.total = this.calculateTotal(produto);
      });
    },
    defineCasaDecimal() {
      const produtos = this.resposta.produtos.map(produto => produto.cotacaoProduto.produto);
      this.casaDecimal = CasaDecimalUtils.getCasaDecimal(produtos);
    },
  },
  created() {
    this.calculateTotalProdutos();
    this.calculateProdutos();
    this.defineCasaDecimal();
  },
};
</script>
